(function ($) {
 	$.fn.capitechDepartmentDutyFilter = function(options) {
		var ctWishFilterModel;
		
		// functions
		/*////////////////////////////////////////////////////////////*/
		function init() {
			createDepartmentDutyFilterModel();
		}
		
		function createDepartmentDutyFilterModel() {
			var wishFilterFormValues = getLocalStorage('myCapitechDutyWishFilterValues');
			var wishFilterSelectedValues = getLocalStorage('myCapitechDutyWishFilter');
			var aSelectedDepartmentIds = wishFilterSelectedValues.departmentIds;
			var aSelectedDutyTypeIds = wishFilterSelectedValues.dutyTypeIds;
		
			var modelData = {};
			modelData.dutyWishFilterDepartments = wishFilterFormValues.departments;
			modelData.dutyWishFilterDutyTypes = wishFilterFormValues.dutyTypes;
			modelData.bAlwaysShowDuties =  wishFilterSelectedValues.displayAvaliableDutiesOnDaysIAlreadyHaveOtherDuties
		
			$(modelData.dutyWishFilterDepartments).each(function(index,obj) {
				if (isInArray(obj.id, aSelectedDepartmentIds)) {
					obj.bChecked = true;
				} else {
					obj.bChecked = false;
				}
			});
		
			$(modelData.dutyWishFilterDutyTypes).each(function(index,obj) {
				if (isInArray(obj.id, aSelectedDutyTypeIds)) {
					obj.bChecked = true;
				} else {
					obj.bChecked = false;
				}
			});
		
			ctWishFilterModel = ko.viewmodel.fromModel(modelData);
			$('*[data-ko-bind="ctWishFilterModel"]').each(function(index, obj) {
				ko.applyBindings(ctWishFilterModel, obj);
			});
		}
		
		
		$('.ct-btn-select-all').click(function(evt) {
			evt.preventDefault();
			var $this = $(this);
			var markCheckbox = true;
			if ($this.val() == 'false') {
				markCheckbox = false;
			}
			$this.parents('.col-md-6').find('.ct-checkbox-group input:checkbox').each(function(index, obj) {
				$(obj).prop('checked', markCheckbox);
			});
		});
		
		$(this).submit(function(evt) {
			evt.preventDefault();
			var $this = $(this);
			var aNewDepartmentIds = [-1];
			var aNewDutyTypeIds = [-1];
			var newAlwaysShowDuties = $('#alwaysShowDuties').is(':checked');
			var success = function(data, textStatus, jqXHR) {
				loaderIndicator(false);
				if (data.success == true) {
					var myCapitechDutyWishFilter = getLocalStorage('myCapitechDutyWishFilter');
					myCapitechDutyWishFilter.departmentIds = aNewDepartmentIds;
					myCapitechDutyWishFilter.dutyTypeIds = aNewDutyTypeIds;
					myCapitechDutyWishFilter.displayAvaliableDutiesOnDaysIAlreadyHaveOtherDuties = newAlwaysShowDuties;
					setLocalStorage('myCapitechDutyWishFilter', myCapitechDutyWishFilter);
					sweetAlert(getResource('app.informationTitle'), getResource('filterDutyWish.filterChangedText', "Avdeling og vaktfilteret er endret."), "success");
				} else {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			}
			var error = function error(jqXHR, textStatus, errorThrown) {
				loaderIndicator(false);
				sweetAlert("Error", errorThrown, "error");
			};
			
			$this.find('input[name=departmentIds]:checked').map(function() {
				aNewDepartmentIds.push(parseInt($(this).val()));
			});
			$this.find('input[name=dutyTypeIds]:checked').map(function() {
				aNewDutyTypeIds.push(parseInt($(this).val()));
			});
			
			loaderIndicator();
			_api.saveDutyWishFilter_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME), aNewDepartmentIds, aNewDutyTypeIds, newAlwaysShowDuties);
		})
		
		// init
		/*////////////////////////////////////////////////////////////*/
		init();
		
	};
}(jQuery));